import axios from 'axios'
import { saleCommissionUrl, saleOrderUrl, salesUrl, getHeader } from '@/config'

const state = {
  salesTypeList: [],
  saleStatusList: [],
  salesList: [],
  salesTermConditionList: [],
  deliveryTypeList: [],
  order: {
    details: []
  },
  latestOrderList: {},
  latestSalesList: {},
  sale: {
    id: null,
    sale_no: null,
    subtotal: '0',
    tax: '0',
    discount: '0',
    total: '0',
    details: [{
      id: null,
      subtotal: '0',
      price: '0',
      tax: '0',
      discount: '0',
      total: '0'
    }],
    payments: [{
      id: null,
      payment_no: null,
      sale_no: null,
      payment_date: null,
      price: '0',
      method_id: null,
      method: null,
      type_id: null,
      type: null,
      bank_id: null,
      bank: null,
      notes: null
    }],
    returs: [{
      id: null,
      type: null,
      return_no: null,
      return_date: null,
      deliver_date: null,
      purchasing_no: null,
      sale_no: null,
      notes: null,
      status: null,
      branch_no: null,
      branch: null,
      company_no: null,
      company: null,
      lock: null,
      is_deliver: false,
      customer_no: null,
      customer: null,
      vendor_no: null,
      vendor: null,
      subtotal: '0',
      discount: '0',
      discount_percentage: '0',
      tax_id: null,
      tax: '0',
      total: '0',
      details: [{
        id: null,
        return_no: null,
        product_no: null,
        product: null,
        product_sku: null,
        serial_number: null,
        uom_id: null,
        qty: '0',
        amount: '0',
        notes: null,
        warehouse_no: null,
        warehouse: null,
        branch_no: null,
        company_no: null,
        discount: null,
        discount_percentage: null,
        tax_id: null,
        tax: '0',
        taxes: null,
        total: '0',
        return_date: null,
        cost: '0',
        cost_id: null
      }]
    }]
  },
  urlInvoice: null,
  saleCommissionList: []
}

const mutations = {
  SET_SALES_TYPE_LIST (state, obj) {
    state.salesTypeList = obj
  },
  SET_STATUS_LIST (state, obj) {
    state.saleStatusList = obj
  },
  SET_SALES_LIST (state, obj) {
    state.salesList = obj
  },
  SET_SALES_TERM_CONDITIONS (state, obj) {
    state.salesTermConditionList = obj
  },
  SET_DELIVERY_TYPE_LIST (state, obj) {
    state.deliveryTypeList = obj
  },
  SET_SALE_ORDER_BY_NO (state, obj) {
    state.order = obj
  },
  SET_SALE_BY_NO (state, obj) {
    state.sale = obj
  },
  SET_SALE_ORDER_LATEST_ORDER_LIST (state, obj) {
    state.latestOrderList = obj
  },
  SET_SALES_LATEST (state, obj) {
    state.latestSalesList = obj
  },
  SET_SALES_URL_INCOIVE (state, obj) {
    state.urlInvoice = obj
  },
  SET_SALE_COMMISSION_LIST (state, obj) {
    state.saleCommissionList = obj
  }
}

const actions = {
  getSaleCommission: ({ commit }) => {
    axios.get(saleCommissionUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_SALE_COMMISSION_LIST', response.data.data)
      })
  },
  getSaleByNo: ({ commit }, payload) => {
    axios.post(salesUrl + '/get-sale-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_SALE_BY_NO', response.data.data)
      })
  },
  getOrderByNo: ({ commit }, payload) => {
    axios.post(saleOrderUrl + '/get-order-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_SALE_ORDER_BY_NO', response.data.data)
      })
  },
  getDeliveryTypeList: ({ commit }) => {
    axios.get(salesUrl + '/delivery/type', { headers: getHeader() })
      .then(response => {
        commit('SET_DELIVERY_TYPE_LIST', response.data.data)
      })
  },
  getSalesTermConditions: ({ commit }) => {
    axios.get(salesUrl + '/term-condition', { headers: getHeader() })
      .then(response => {
        commit('SET_SALES_TERM_CONDITIONS', response.data.data)
      })
  },
  getSalesTypeList: ({ commit }) => {
    axios.get(salesUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_SALES_TYPE_LIST', response.data.data)
      })
  },
  getSaleStatusList: ({ commit }) => {
    axios.get(salesUrl + '/status', { headers: getHeader() })
      .then(response => {
        commit('SET_STATUS_LIST', response.data.data)
      })
  },
  getSalesList: ({ commit }) => {
    axios.get(salesUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_SALES_LIST', response.data.data)
      })
  },
  getSalesLatestOrder: ({ commit }, payload) => {
    axios.post(saleOrderUrl + '/get-latest-order', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_SALE_ORDER_LATEST_ORDER_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
